import { useCallback } from 'react';
import { useFetcher } from 'react-router';

import { useBloomBasename } from '@jane/bloom/hooks/useBloomBasename';
import type {
  LoginUserResponse,
  Payload,
} from '@jane/bloom/routes/$basename.api.login/types';
import { buildFormData } from '@jane/bloom/utils/formData';

export const useLogin = () => {
  const basename = useBloomBasename();
  const fetcher = useFetcher<LoginUserResponse>();

  const login = useCallback(
    (payload: Payload) => {
      return fetcher.submit(buildFormData(payload), {
        action: `${basename}api/login`,
        method: 'post',
        preventScrollReset: true,
      });
    },
    [basename, fetcher]
  );

  return {
    fetcher,
    login,
  };
};
